import { Part, PartProduct, ProductSpecCode, ProductSpecs } from '../../types/productSchema';

export const getProductSpecsToString = (productSpecs: ProductSpecs[], part: Part | PartProduct): string => {
  switch (part) {
    case Part.TruckTires:
      return (
        `
        ${productSpecs.find(x => x.code === ProductSpecCode.TruckTyresWidth)?.value || ''}/` +
        `${productSpecs.find(x => x.code === ProductSpecCode.TruckTyresHeight)?.value || ''}
        R${productSpecs.find(x => x.code === ProductSpecCode.TruckTyresDiam)?.value || ''}
        ${productSpecs.find(x => x.code === ProductSpecCode.TruckTyresLoad)?.value || ''}
        ${productSpecs.find(x => x.code === ProductSpecCode.TruckTyresSpeed)?.value || ''}
    `
      );
    case Part.Tyres:
      return (
        `
        ${productSpecs.find(x => x.code === ProductSpecCode.Width)?.value || ''}/` +
        `${productSpecs.find(x => x.code === ProductSpecCode.Height)?.value || ''}
        R${productSpecs.find(x => x.code === ProductSpecCode.Diameter)?.value || ''}
        ${productSpecs.find(x => x.code === ProductSpecCode.LoadIndex)?.value || ''}
        ${productSpecs.find(x => x.code === ProductSpecCode.SpeedIndex)?.value || ''}
        ${productSpecs.find(x => x.code === ProductSpecCode.Loads)?.value || ''}
        ${Number(productSpecs.find(x => x.code === ProductSpecCode.RunFlat)?.value) ? 'RunFlat' : ''}
    `
      );
    case Part.Disks:
      return (
        `
        ${productSpecs.find(x => x.code === ProductSpecCode.DiskWidth)?.value || ''}x` +
        `${productSpecs.find(x => x.code === ProductSpecCode.DiskRadius)?.value || ''} 
        ${productSpecs.find(x => x.code === ProductSpecCode.DiskUnitedPcd)?.value || ''} 
        ET${productSpecs.find(x => x.code === ProductSpecCode.DiskEt)?.value || ''} 
        Dia${productSpecs.find(x => x.code === ProductSpecCode.DiskDia)?.value || ''}  
        ${productSpecs.find(x => x.code === ProductSpecCode.DiskColor)?.value || ''} 
        ${productSpecs.find(x => x.code === ProductSpecCode.DiskProcessWay)?.value || ''} 
        `
      );
    case Part.Batteries:
      return (
        `
        ${productSpecs.find(x => x.code === ProductSpecCode.AkbCapacity)?.value || ''}Ah
        ${productSpecs.find(x => x.code === ProductSpecCode.AkbCranking)?.value || ''}
        ${Number(productSpecs.find(x => x.code === ProductSpecCode.AkbPolarity)?.value) ? '(прям)' : '(обр)'}
         ${productSpecs.find(x => x.code === ProductSpecCode.AkbLength)?.value || ''}x` +
        `${productSpecs.find(x => x.code === ProductSpecCode.AkbWidth)?.value || ''}x` +
        `${productSpecs.find(x => x.code === ProductSpecCode.AkbHeight)?.value || ''}
    `
      );
    default:
      return '';
  }
};
